export function initHeroCanvas() {
  const canvas = document.querySelector(".hero-canvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  let width = 0;
  let height = 0;
  let t = 0;

  const resize = () => {
    const rect = canvas.parentElement.getBoundingClientRect();
    width = rect.width;
    height = rect.height;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };

  const draw = () => {
    t += 0.004;
    ctx.clearRect(0, 0, width, height);
    const cx = width * 0.62;
    const cy = height * 0.42;

    for (let i = 0; i < 5; i += 1) {
      const r = 90 + i * 70 + Math.sin(t + i) * 18;
      ctx.beginPath();
      ctx.ellipse(cx, cy, r * 1.4, r, t * 0.4 + i, 0, Math.PI * 2);
      ctx.strokeStyle = i % 2 === 0 ? "rgba(215,161,92,0.18)" : "rgba(110,224,200,0.12)";
      ctx.lineWidth = 1.2;
      ctx.stroke();
    }

    for (let i = 0; i < 48; i += 1) {
      const a = t * 0.8 + (i / 48) * Math.PI * 2;
      const radius = 160 + Math.sin(t * 2 + i) * 40;
      const x = cx + Math.cos(a) * radius * 1.5;
      const y = cy + Math.sin(a * 0.9) * radius;
      ctx.fillStyle = i % 3 === 0 ? "rgba(215,161,92,0.55)" : "rgba(238,242,247,0.28)";
      ctx.beginPath();
      ctx.arc(x, y, i % 5 === 0 ? 2.4 : 1.2, 0, Math.PI * 2);
      ctx.fill();
    }

    requestAnimationFrame(draw);
  };

  resize();
  window.addEventListener("resize", resize);
  draw();
}
